import {Box, Tabs} from '@logistics-frontend/blocks'
import {TabItem} from '@logistics-frontend/blocks/tabs/Tabs'
import {useCallback, useMemo} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {OrderFormState} from '../..'
import {renderWidget} from '..'
import {SegmentWidgetConfig} from '../types'
import {segment} from './Segment.classes'

export const SegmentWidget = ({action: {form_state_key, options}}: SegmentWidgetConfig): React.ReactElement => {
  const {control} = useFormContext<OrderFormState>()
  const {field} = useController({
    name: form_state_key,
    control,
    defaultValue: options.find(option => option.default)?.value,
  })

  const items: Array<TabItem<string>> = useMemo(
    () =>
      options.map(option => ({
        value: String(option.value),
        label: option[option.value === field.value ? 'selected_text' : 'unselected_text'].title.items.map(item => (
          <Box px="s">{renderWidget(item)}</Box>
        )),
      })),
    [field.value, options],
  )

  const disabled: Array<string> | undefined = useMemo(
    () => options.filter(option => !option.is_available).map(option => String(option.value)),
    [options],
  )

  const handleChange = useCallback(
    (value: string) => {
      if (value !== field.value) {
        field.onChange(Number.parseInt(value))
      }
    },
    [field],
  )

  return (
    <Tabs.Segments<string>
      className={segment}
      disabled={disabled}
      items={items}
      onChange={handleChange}
      size="s"
      value={String(field.value)}
    />
  )
}
